export default {
  access_token: null,
  refresh_token: null,
  user_info: null,
  language_preference: null,
  permissions: [],
  permissions_promise: null,
  program_code: null,
  isLoading: false,
}
